import { useState } from "react";

export const useTableAnchorsState = () => {
  const [searchMenuAnchor, setSearchMenuAnchor] = useState<null | HTMLElement>(
    null
  );
  const [filterMenuAnchor, setFilterMenuAnchor] = useState<null | HTMLElement>(
    null
  );
  const [editAssetsAnchor, setEditAssetsAnchor] = useState<null | HTMLElement>(
    null
  );
  const [editTicketsAnchor, setEditTicketsAnchor] = useState<null | HTMLElement>(
    null
  );
  const [editUsersAnchor, setEditUsersAnchor] = useState<null | HTMLElement>(
    null
  );
  const [settingsAnchor, setSettingsAnchor] = useState<null | HTMLElement>(
    null
  );
  const [deleteAssetsAnchor, setDeleteAssetsAnchor] =
    useState<null | HTMLElement>(null);
  const [deleteItemsAnchor, setDeleteItemsAnchor] =
    useState<null | HTMLElement>(null);

  return {
    searchMenuAnchor,
    setSearchMenuAnchor,
    filterMenuAnchor,
    setFilterMenuAnchor,
    editAssetsAnchor,
    setEditAssetsAnchor,
    editTicketsAnchor,
    setEditTicketsAnchor,
    editUsersAnchor,
    setEditUsersAnchor,
    deleteAssetsAnchor,
    setDeleteAssetsAnchor,
    deleteItemsAnchor,
    setDeleteItemsAnchor,
    settingsAnchor,
    setSettingsAnchor,
  };
};
